import React, { Component } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Icon, ScrollArea } from '@adc/ui-core'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

class ClauseHolder extends Component {
  state = {
    hasOverflow: false,
  }

  static propTypes = {
    clauses: PropTypes.array.isRequired,
    clearFilters: PropTypes.func.isRequired,
    removeFilter: PropTypes.func.isRequired,
    onFilterClick: PropTypes.func.isRequired,
    className: PropTypes.string,
  }

  /**
   * This is for letting the searchField know that the user clicked on a clause pill, so that it the currently
   * selected field can be selected in the searchField dropdown.
   */
  onFilterClick = index => () => {
    return this.props.onFilterClick(null, {
      value:
        _.get(this, `props.clauses[${index}].fields.length`) === 1
          ? this.props.clauses[index].fields[0]
          : '',
    })
  }

  onOverflowChange = hasOverflow => {
    this.setState({ hasOverflow })
  }

  renderClause = (clause, index) => (
    <div
      className={cx('lozenge')}
      key={index}
      data-elm-id={`clause_${index}`}
      onClick={this.onFilterClick(index)}
    >
      <Icon
        data-elm-id={`clause_remove_${index}`}
        name='close'
        className={cx('close-button')}
        onClick={() => this.props.removeFilter(this.props.clauses[index])}
      />
      <p data-elm-id={`clause_title_${index}`} className={cx('title')}>
        {clause.title}
      </p>
      <p data-elm-id={`clause_subtitle_${index}`} className={cx('subtitle')}>
        {clause.valuesAsText}
      </p>
    </div>
  )

  clearFilters = e => {
    this.props.clearFilters()
    e.preventDefault()
  }

  render() {
    const { clauses, className } = this.props
    const { hasOverflow } = this.state

    return (
      <div className={className} data-elm-id='clause_holder'>
        <div
          className={cx('clear-button')}
          style={{ display: clauses.length ? 'block' : 'none' }}
        >
          {`${clauses.length} Filter${clauses.length === 1 ? '' : 's'}`}
          <a data-elm-id='clear_filters' href='#' onClick={this.clearFilters}>
            Clear All
          </a>
        </div>

        <ScrollArea
          elmId='clause_scroll_area'
          className={cx('scroll-area-container', {
            'end-shadow': hasOverflow,
          })}
          contentClassName={cx('scroll-area-content')}
          onOverflowChange={this.onOverflowChange}
        >
          {clauses.map(this.renderClause)}
        </ScrollArea>
      </div>
    )
  }
}

export default ClauseHolder
